import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink } from "react-router-dom";
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import { use } from 'react';

function Attendancelist() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const navigate = useNavigate();
    const Swal = require('sweetalert2')
    const defaultValue = new Date().toLocaleDateString("en-CA");

    const [selectedBranch, setSelectedBranch] = useState(null);

    const [branches, setBranches] = useState([]);

    const [depts, setdepts] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");


    const [shifts, setShifts] = useState([]);
    const [selectedShift, setSelectedShift] = useState('');
    const [staffList, setStaffList] = useState([]);
    const [staffListmode, setStaffListmode] = useState([]);
    const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().split('T')[0]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [punchTime, setPunchTime] = useState("");
    const [isPunchOut, setIsPunchOut] = useState(false);

    const [showBulkModal, setShowBulkModal] = useState(false);
    const [bulkPunchTime, setBulkPunchTime] = useState("");
    const getShiftTypes = () => {
        axios.get(`${baseurladdress}findallshifttypes`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                setShifts(res.data.response);
                setSelectedShift('');
            })
            .catch(err => alert("Error loading shifts: " + err));
    };




    const getbranch = () => {
        axios.get(baseurladdress + `findallbranches`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setBranches(data);
            })
            .catch(error => {
                alert(error);
            });
    };




    const getdept = () => {
        axios.get(baseurladdress + `findalldept`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setdepts(data);
            })
            .catch(error => {
                alert(error);
            });
    };




    const getStaffByBranch = (branchId) => {
        axios.get(`${baseurladdress}staffbybranch/${branchId}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                setStaffList(res.data.response);
            })
            .catch(err => {
                alert("Error loading staff list: " + err);
            });
    };



    const getStaffList = (branchId, shiftTypeId, date, deptId = null) => {
        if (!branchId || !shiftTypeId || !date) return;

        // Check if selected date is today or earlier
        const selected = new Date(date);
        const today = new Date();

        selected.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (selected > today) {
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Cannot fetch staff names for future dates",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            });

            return;
        }

        const url = `${baseurladdress}stafflist/${branchId}/${shiftTypeId}/${date}/${deptId ?? 'null'}`;

        axios.get(url, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                setStaffListmode(res.data.response);
            })
            .catch(err => {
                alert("Failed to load staff list: " + (err.response?.data?.error || err.message));
            });
    };


    useEffect(() => {
        getbranch();
        getdept();
        getShiftTypes();
        getStaffByBranch();
        getStaffList();
    }, [])






    const handleCheckboxChange = (staff) => {
        setSelectedEmployees(prev => {
            const exists = prev.find(e => e.staff_id === staff.staff_id);
            if (exists) {
                return prev.filter(e => e.staff_id !== staff.staff_id);
            } else {
                return [...prev, staff];
            }
        });
    };


    const handleShiftChange = (e) => {
        const shiftTypeId = e.target.value;
        setSelectedShift(shiftTypeId);

        if (selectedBranch?.branch_id && shiftTypeId && selectedDate) {
            setStaffList([]);
            setStaffListmode([]);

            getStaffList(selectedBranch.branch_id, shiftTypeId, selectedDate);
        }
    };





    // const handleSingleAttendanceSubmit = async (staff) => {
    //     if (!selectedBranch || !selectedShift || !selectedDate || !staff?.staff_id || !staff?.staff_name) {
    //         Swal.fire({
    //             toast: true,
    //             position: "top-end",
    //             icon: "error",
    //             title: "Please select Branch, Shift, Date, and Staff",
    //             showConfirmButton: false,
    //             timer: 2000,
    //             timerProgressBar: true,
    //         });
    //         return;
    //     }

    //     const payload = [{
    //         attendance_empid: staff.staff_id,
    //         attendance_empname: staff.staff_name,
    //         attendance_branchid: selectedBranch.branch_id,
    //         attendance_branchname: selectedBranch.branch_name,
    //         attendance_shiftid: selectedShift,
    //         attendance_shiftname: staff.type_name,
    //         attendance_date: selectedDate,
    //         attendance: 1,
    //         attendance_punching: "",
    //         attendance_punchout: "",
    //         attendance_crtby: accessuserid
    //     }];

    //     try {
    //         const response = await fetch(`${baseurladdress}mark-attendance`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${accesstoken}`,
    //             },
    //             body: JSON.stringify({ attendance: payload }),
    //         });

    //         const result = await response.json();

    //         if (response.ok) {
    //             const updated = staffListmode.map(emp =>
    //                 emp.staff_id === staff.staff_id ? { ...emp, attendance: 1 } : emp
    //             );
    //             setStaffListmode(updated);

    //             Swal.fire({
    //                 toast: true,
    //                 position: "top-end",
    //                 icon: "success",
    //                 title: `${staff.staff_name} marked as Present`,
    //                 showConfirmButton: false,
    //                 timer: 1500,
    //                 timerProgressBar: true,
    //             });
    //         } else {
    //             Swal.fire({
    //                 toast: true,
    //                 position: "top-end",
    //                 icon: "error",
    //                 title: result.message || "Failed to mark attendance",
    //                 showConfirmButton: false,
    //                 timer: 2000,
    //                 timerProgressBar: true,
    //             });
    //         }
    //     } catch (error) {
    //         console.error("Error marking attendance:", error);
    //         Swal.fire({
    //             toast: true,
    //             position: "top-end",
    //             icon: "error",
    //             title: "Server error. Please try again.",
    //             showConfirmButton: false,
    //             timer: 2000,
    //             timerProgressBar: true,
    //         });
    //     }
    // };


    const handleSubmitAttendance = async () => {
        if (!selectedStaff || !punchTime) {
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Please select a time",
                showConfirmButton: false,
                timer: 2000,
            });
            return;
        }

        const payload = [{
            attendance_empid: selectedStaff.staff_id,
            attendance_empname: selectedStaff.staff_name,
            attendance_branchid: selectedBranch.branch_id,
            attendance_branchname: selectedBranch.branch_name,
            attendance_shiftid: selectedShift,
            attendance_shiftname: selectedStaff.type_name,
            attendance_date: selectedDate,
            attendance: 1,
            attendance_punching: isPunchOut ? "" : punchTime,
            attendance_punchout: isPunchOut ? punchTime : "",
            attendance_crtby: accessuserid
        }];
        try {
            const response = await fetch(`${baseurladdress}mark-attendance`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify({ attendance: payload }),
            });

            const result = await response.json();

            if (response.ok) {
                const updated = staffListmode.map(emp =>
                    emp.staff_id === selectedStaff.staff_id
                        ? {
                            ...emp,
                            attendance: 1,
                            punchStatus: isPunchOut ? "out" : "in",
                        }
                        : emp
                );
                setStaffListmode(updated);
                setShowModal(false);
                setIsPunchOut(false);

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: `${selectedStaff.staff_name}'s ${isPunchOut ? "Punch Out" : "Punch In"} has been recorded successfully.`,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } catch (error) {
            console.error("Error marking attendance:", error);
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Server error. Please try again.",
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };



    const markBulkAttendance = async () => {
        if (!selectedBranch || !selectedShift || !selectedDate || selectedEmployees.length === 0) {
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Please select Branch, Shift, Date, and at least one staff",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            });
            return;
        }

        const payload = selectedEmployees.map(staff => ({
            attendance_empid: staff.staff_id,
            attendance_empname: staff.staff_name,
            attendance_branchid: selectedBranch.branch_id,
            attendance_branchname: selectedBranch.branch_name,
            attendance_shiftid: selectedShift,
            attendance_shiftname: staff.type_name,
            attendance_date: selectedDate,
            attendance: 1,
            attendance_punching: isPunchOut ? "" : punchTime,
            attendance_punchout: isPunchOut ? punchTime : "",
            attendance_crtby: accessuserid
        }));

        try {
            const response = await fetch(`${baseurladdress}mark-attendance`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify({ attendance: payload }),
            });

            const result = await response.json();

            if (response.ok) {
                const updated = staffListmode.map(emp =>
                    selectedEmployees.some(sel => sel.staff_id === emp.staff_id)
                        ? { ...emp, attendance: 1, punchStatus: isPunchOut ? "out" : "in" }
                        : emp
                );
                setStaffListmode(updated);


                setPunchTime("");
                setIsPunchOut(prev => !prev);
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Attendance marked successfully",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            } else {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "error",
                    title: result.message || "Bulk attendance failed",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            }
        } catch (err) {
            console.error("Bulk API call failed:", err);
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Server error. Please try again.",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            });
        }
    };

    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <h6 className="card-title">Attendance List</h6>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            if (selectedEmployees.length === 0) {
                                                Swal.fire({
                                                    toast: true,
                                                    position: "top-end",
                                                    icon: "error",
                                                    title: "Please select employees",
                                                    showConfirmButton: false,
                                                    timer: 2000,
                                                });
                                                return;
                                            }
                                            setPunchTime("");
                                            setShowModal(true);
                                        }}
                                        disabled={selectedEmployees.length === 0}
                                    >
                                        Mark Attendance
                                    </button>

                                </div>
                                <div className="card-body">

                                    <div className="row mb-3">

                                        <div className="col-sm-3">
                                            <h6>Branch</h6>
                                            <select
                                                className="form-control"
                                                value={selectedBranch?.branch_name || ''}
                                                onChange={(e) => {
                                                    const branch = branches.find(item => item.branch_name === e.target.value);
                                                    setSelectedBranch(branch);
                                                    setSelectedDepartment(null);
                                                    setStaffList([]);
                                                    setStaffListmode([]);


                                                    if (branch?.branch_id) {
                                                        getShiftTypes(branch.branch_id);
                                                        getStaffByBranch(branch.branch_id);
                                                    }
                                                }}
                                            >
                                                <option value="">Choose branch</option>
                                                {branches.map((item) => (
                                                    <option key={item.branch_id} value={item.branch_name}>
                                                        {item.branch_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                        <div className="col-sm-3">
                                            <h6>Shift</h6>
                                            <select
                                                className="form-control"
                                                value={selectedShift}
                                                onChange={handleShiftChange}
                                                disabled={!selectedBranch}
                                            >
                                                <option value="">Choose shift type</option>
                                                {shifts.map((shift) => (
                                                    <option key={shift.type_id} value={shift.type_id}>
                                                        {shift.type_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>



                                        <div className="col-sm-3">
                                            <h6>Date </h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={selectedDate}
                                                onChange={(e) => {
                                                    const date = e.target.value;
                                                    setSelectedDate(date);

                                                    if (selectedBranch?.branch_id && selectedShift && date) {
                                                        setStaffList([]);
                                                        setStaffListmode([]);
                                                        getStaffList(selectedBranch.branch_id, selectedShift, date);
                                                    }
                                                }}
                                            />

                                        </div>







                                        <div className="col-sm-3">
                                            <h6>Department</h6>
                                            <select
                                                className="form-control"
                                                value={selectedDepartment?.dept_name || ''}
                                                onChange={(e) => {
                                                    const dept = depts.find(d => d.dept_name === e.target.value);
                                                    setSelectedDepartment(dept);

                                                    if (selectedBranch?.branch_id && selectedShift && selectedDate) {
                                                        getStaffList(
                                                            selectedBranch.branch_id,
                                                            selectedShift,
                                                            selectedDate,
                                                            dept?.dept_id || null
                                                        );
                                                    }
                                                }}
                                                disabled={!(selectedBranch && selectedShift)}
                                            >
                                                <option value="">Choose department</option>
                                                {depts.map((dept) => (
                                                    <option key={dept.dept_id} value={dept.dept_name}>
                                                        {dept.dept_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>





                                    </div>



                                    {/* Staff Table */}
                                    <div className="col-sm-12 card mt-3">
                                        <div className="card-header"><h5>Select Employees</h5></div>
                                        <div className="card-body">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        // Select all employees not already marked as present
                                                                        const allSelectable = staffListmode.length > 0
                                                                            ? staffListmode.filter(staff => staff.attendance !== 1)
                                                                            : staffList.filter(staff => !staff.isMarkedPresent);
                                                                        setSelectedEmployees(allSelectable);
                                                                    } else {
                                                                        setSelectedEmployees([]);
                                                                    }
                                                                }}
                                                                checked={
                                                                    (staffListmode.length > 0 &&
                                                                        staffListmode.filter(staff => staff.attendance !== 1).every(staff =>
                                                                            selectedEmployees.some(e => e.staff_id === staff.staff_id)
                                                                        )) ||
                                                                    (staffList.length > 0 &&
                                                                        staffList.filter(staff => !staff.isMarkedPresent).every(staff =>
                                                                            selectedEmployees.some(e => (e.emp_id || e.staff_id) === (staff.emp_id || staff.staff_id))
                                                                        ))
                                                                }
                                                            />
                                                        </th>
                                                        {/* <th style={{ textAlign: 'left' }}>Select</th> */}
                                                        <th style={{ textAlign: 'left' }}>Employee Name</th>
                                                        <th style={{ textAlign: 'left' }}>Shift</th>
                                                        <th style={{ textAlign: 'left' }}>Date</th>
                                                        <th style={{ textAlign: 'left' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {staffListmode.length > 0 ? (
                                                        staffListmode.map((staff) => (
                                                            <tr key={`mode-${staff.staff_id}`}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        disabled={staff.attendance === 1}
                                                                        onChange={() => handleCheckboxChange(staff)}
                                                                        checked={selectedEmployees.some(e => e.staff_id === staff.staff_id)}
                                                                    />
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>{staff.staff_name}</td>

                                                              
                                                                < td style = {{ textAlign: "left" }}>
                                                                    {staff.type_name || "-"}

                                                                    {staff.type_from && staff.type_to ? (
                                                                        <>
                                                                            &nbsp; : &nbsp;
                                                                            {new Date(`1970-01-01T${staff.type_from}`).toLocaleTimeString([], {
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                            })}
                                                                            {" - "}
                                                                            {new Date(`1970-01-01T${staff.type_to}`).toLocaleTimeString([], {
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                            })}
                                                                        </>
                                                                    ) : (
                                                                        " No Shift Time"
                                                                    )}

                                                                    &nbsp;

                                                                    {Number(staff.shiftmode) === 2 && (
                                                                        <strong style={{ color: "green" }}>
                                                                            (Intra Shift)
                                                                        </strong>
                                                                    )}

                                                                    {Number(staff.shiftmode) === 1 && (
                                                                        <strong style={{ color: "blue" }}>
                                                                            (Inter Shift)
                                                                        </strong>
                                                                    )}
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    {(() => {
                                                                        const date = new Date(selectedDate);
                                                                        const day = String(date.getDate()).padStart(2, '0');
                                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                        const year = date.getFullYear();
                                                                        return `${day}-${month}-${year}`;
                                                                    })()}
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    {staff.punchStatus === "in" ? (
                                                                        <button
                                                                            className="btn btn-warning btn-sm rounded"
                                                                            title="Click to Punch Out"
                                                                            onClick={() => {
                                                                                setSelectedStaff(staff);
                                                                                setPunchTime("");
                                                                                setIsPunchOut(true);
                                                                                setShowModal(true);
                                                                            }}
                                                                        >
                                                                            IN
                                                                        </button>
                                                                    ) : staff.punchStatus === "out" ? (
                                                                        <button className="btn btn-secondary btn-sm rounded" disabled>
                                                                            OUT
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="btn btn-success btn-sm rounded"
                                                                            onClick={() => {
                                                                                setSelectedStaff(staff);
                                                                                setPunchTime("");
                                                                                setIsPunchOut(false);
                                                                                setShowModal(true);
                                                                            }}
                                                                        >
                                                                            Present
                                                                        </button>
                                                                    )}
                                                                </td>

                                                            </tr>
                                                        ))
                                                    ) : staffList.length > 0 ? (
                                                        staffList.map((staff) => (
                                                            <tr key={staff.staff_id}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        disabled={staff.isMarkedPresent}
                                                                        onChange={() => handleCheckboxChange(staff)}
                                                                        checked={selectedEmployees.some(e => (e.emp_id || e.staff_id) === (staff.emp_id || staff.staff_id))}
                                                                    />

                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>{staff.staff_name}</td>
                                                                <td></td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    {(() => {
                                                                        const date = new Date(selectedDate);
                                                                        const day = String(date.getDate()).padStart(2, '0');
                                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                        const year = date.getFullYear();
                                                                        return `${day}-${month}-${year}`;
                                                                    })()}
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    <button className="btn btn-success btn-sm rounded">
                                                                        Present
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center text-muted">No staff found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                    {showModal && (
                        <div className="modal show d-block" tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Mark Attendance</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowModal(false)}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>
                                            {isPunchOut ? (
                                                <>Enter punch-out time for <strong>selected employees</strong>:</>
                                            ) : (
                                                <>Enter punch-in time for <strong>selected employees</strong>:</>
                                            )}
                                        </p>
                                        <input
                                            type="time"
                                            className="form-control"
                                            value={punchTime}
                                            onChange={(e) => setPunchTime(e.target.value)}
                                        />
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-success"
                                            onClick={() => {
                                                if (!punchTime) {
                                                    Swal.fire({
                                                        toast: true,
                                                        position: "top-end",
                                                        icon: "error",
                                                        title: "Please select time",
                                                        showConfirmButton: false,
                                                        timer: 2000,
                                                    });
                                                    return;
                                                }
                                                markBulkAttendance();
                                                setShowModal(false);
                                            }}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div >

        </div >
    );
}

export default Attendancelist;
